<template>
  <div id="contenedor-infraestructura-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar  titulo="Infraestructura">
            <template v-slot:opciones-derecha>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{ name: 'infraestructuraConfiguracionTiposInfraestructura' }"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>
                <span> Configuración </span>
              </v-tooltip>
            </template>
            </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:agregarInfraestructura="registrarNuevaInfraestructura"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado
            :listadoInfraestructura="getListadoInfraestructuras">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana Agregar Infraestructura -->
    <v-dialog
      v-if="mostrarVentanaRegistrarNuevaInfraestructura"
      v-model="mostrarVentanaRegistrarNuevaInfraestructura"
      :width="!$vuetify.breakpoint.mobile ? '900' : '90%'"
      persistent
      scrollable>
      <agregar-infraestructura
        v-on:cerrar="cerrarVentana">
      </agregar-infraestructura>
    </v-dialog>
    <v-dialog
      v-if="estaInfraestructura"
      v-model="mostrarVentanaEditarInfraestructura"
      :width="!$vuetify.breakpoint.mobile ? '900' : '90%'"
      persistent
      scrollable>
      <editar-infraestructura
        :infraestructuraEditar="estaInfraestructura"
        v-on:cerrar="cerrarVentana">
      </editar-infraestructura>
    </v-dialog>
    <!-- Ventana Eliminar Infraestructura -->
    <v-dialog
      v-if="estaInfraestructura"
      v-model="mostrarVentanaEliminarInfraestructura"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-infraestructura
        :infraestructuraEliminar="estaInfraestructura"
        v-on:cerrar="cerrarVentana">
      </eliminar-infraestructura>
    </v-dialog>
  </div>
</template>

<script>
import INFRAESTRUCTURAS from '@/graphql/querys/administracion/infraestructuras/infraestructuras.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarInfraestructura from '@/components/administracion/infraestructura/Nueva.vue';
import EditarInfraestructura from '@/components/administracion/infraestructura/Editar.vue';
import EliminarInfraestructura from '@/components/administracion/infraestructura/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'AdjudicacionesDefault',
  components: {
    TituloToolBar,
    AgregarInfraestructura,
    EditarInfraestructura,
    EliminarInfraestructura,
    ToolBar,
    Listado,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarVentanaRegistrarNuevaInfraestructura: false,
      mostrarVentanaEditarInfraestructura: false,
      mostrarVentanaEliminarInfraestructura: false,
      estaInfraestructura: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
      },
    };
  },
  apollo: {
    infraestructuras: {
      query: INFRAESTRUCTURAS,
    },
  },
  mounted() {
    eventBus.$on('editar-infraestructura', (infraestructura) => {
      this.estaInfraestructura = infraestructura;
      this.mostrarVentanaEditarInfraestructura = true;
    });
    eventBus.$on('eliminar-infraestructura', (infraestructura) => {
      this.estaInfraestructura = infraestructura;
      this.mostrarVentanaEliminarInfraestructura = true;
    });
  },
  methods: {
    setFormularioValido(valor) {
      this.formularioValido = valor;
    },
    setEnviandoFormulario(valor) {
      this.enviandoFormulario = valor;
    },
    registrarNuevaInfraestructura() {
      this.mostrarVentanaRegistrarNuevaInfraestructura = true;
      this.enviandoFormulario = false;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevaInfraestructura = false;
      this.mostrarVentanaEditarInfraestructura = false;
      this.mostrarVentanaEliminarInfraestructura = false;
      this.estaInfraestructura = null;
    },
  },
  computed: {
    getListadoInfraestructuras() {
      if (!this.infraestructuras) return [];
      return this.infraestructuras
      // Filtrar por texto
        .filter((infraestructura) => {
          if (!this.filtros.buscarTexto) return infraestructura;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const clave = this.$normalizacionTexto(infraestructura.clave);
          const descripcion = this.$normalizacionTexto(infraestructura.descripcion);
          return (
            expt.test(clave)
          || expt.test(descripcion)
          || expt.test(infraestructura.clave)
          || expt.test(infraestructura.descripcion)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
